module.exports = __webpack_public_path__ + "img/julian-smc.dcb8092f.jpg";